import React from 'react';
import styled from 'styled-components';
import Choice from './Choice';
import config from '../config';

const SChooser = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
`;

const SChooseGrid = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
`;

const SLogoImg = styled.img`
  display: flex;
  max-width: 15vw;
  height: auto;
  margin: 6vh 0 0 0;
`;

interface IScoreChooserProps {}

const ScoreChooser: React.SFC<IScoreChooserProps> = props => (
  <SChooser className='ScoreChooser'>
    <SLogoImg src={process.env.PUBLIC_URL + '/logo_word.png'} alt='form' />

    <h2 style={{ display: 'flex', justifyContent: 'center', margin: '2vh 0 2vh 0' }} className='ScoreChooserText'>
      How are you today?
    </h2>

    <SChooseGrid className='ScoreChooserGrid'>
      {Object.keys(config.formScale)
        .reverse()
        .map((element: any) => (
          <Choice
            key={element}
            scoreValue={element}
            color={config.formScale[element].color}
            description={config.formScale[element].desc}
          />
        ))}
    </SChooseGrid>
  </SChooser>
);

export default ScoreChooser;
